<template>
    <div id="modal-export-image" class="modal-new hidden">
        <svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
        <span class="title">Save Image</span>

        <label for="image-name" theme="--start">Name</label>
        <input type="text"
               v-model="name"
               name="image-name"
               placeholder="E.g. image #5 - (optional)"
        />

        <v-menu offset-y min-width="120" content-class="modal-menu">
            <template v-slot:activator="{ on }">
                <div class="menu-label mb-5" v-on="on">
                    <span class="name">Format: {{ type }}</span>
                    <i class="material-icons">arrow_drop_down</i>
                </div>
            </template>
            <v-list>
                <v-list-item v-for="selectableType in types" :key="selectableType" @click="type = selectableType" :class="{'--selected': selectableType == type}">
                    <v-list-item-title>{{ selectableType }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-expansion-panels accordion :class="{'visibility-hidden': type.toLowerCase() !== 'jpg'}">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <div class="btn-advanced-options">
                        <span>Additional Options</span>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div id="advanced-export-options">
                        <div class="block-sliders-container">
                            <span class="slider-name option-title">Quality</span>
                            <input type="range" v-model="jpgQuality" min="50" max="100" step="1"
                                   class="range_slider adjustmentBlock-slider">
                            <input type="number" v-model="jpgQuality" class="range_value adjustmentBlock-range"
                                   name="quantity" min="50" max="100" step="1">
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="buttons-continer --align-left">
            <button type="button" class="modal-btn --primary" @click="onSubmit" :disabled="exporting">
                <v-progress-circular v-if="exporting" indeterminate color="var(--primary)" size="18"
                                     width="3"></v-progress-circular>
                <span v-else>Save</span>
            </button>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    data() {
        return {
            name: "",
            type: "JPG",
            types: ["JPG", 'PNG', 'TIFF'],
            exporting: false,
            jpgQuality: 100,
        };
    },
    computed: {
        ...mapState("Projects", ["action"]),
    },
    'jpgQuality': function (newVal) {
        console.log(newVal)
    },
    methods: {
        async onSubmit() {
            this.exporting = true;

            await lutify.saveMainImage(this.type.toLowerCase(), this.name, {jpgQuality: this.jpgQuality / 100});

            this.exporting = false;
            window.UI.hideModal();
            this.name = "";
        },
    },
};
</script>

<style lang="scss">
.modal-menu {
    z-index: 10 !important;
    border-radius: var(--box-rounding);
    //padding: 25px 0;
    background: var(--dark-gray);

    .v-list {
        background: var(--dark-gray);
        padding: 25px 0;

        .v-list-item {
            min-height: 20px;
            padding: 0 25px;
            //display: grid;
            //grid-template-columns: 18px 1fr 18px;
            cursor: pointer;

            &.--first {
                order: -1;
            }

            &:hover {
                background: rgb(54, 54, 54);
            }

            &.full-span {
                grid-template-columns: 1fr;
            }

            &.stars-icons-container {
                grid-template-columns: repeat(5, 1fr);
            }

            &[aria-expanded="true"] {
                background: rgb(54, 54, 54);
            }

            &.--selected {
                .material-icons,
                .v-list-item__title {
                    color: var(--primary);
                }
            }

            &.v-list-item--disabled {
                opacity: 0.6;
            }

            .material-icons {
                color: #989898;
                font-size: 18px;
                width: 18px;
            }

            .v-list-item__title {
                margin-left: 4px;
                color: #989898;
                font-size: 1rem;
            }

            &:after {
                display: none;
            }
        }
    }
}

#modal-export-image {
    .visibility-hidden {
        visibility: hidden;
        transition: none;

        * {
            transition: none;
        }
    }

    .menu-label {
        display: flex;
        align-items: center;
        font-size: 13px;
        position: relative;
        .name {
            line-height: 1;
        }
        i {
            font-size: 18px;
        }
    }

    .block-sliders-container {
        input {
            color: #989898
        }
    }

    .switch-container {
        margin-left: initial;
    }

    .option-container {
        .option-title {
            line-height: 20px;
        }
    }

    .btn-advanced-options {
        margin-bottom: 0;

        > span {
            line-height: 20px;
        }
    }

    label {
        margin-bottom: 10px !important;
    }

    textarea,
    input {
        line-height: 20px;
    }

    textarea {
        width: 100%;
        margin-bottom: 12px;
    }

    .description-container {
        margin-bottom: 8px;

        .v-expansion-panel-header {
            span {
                line-height: 12px;
            }
        }
    }

    div[name="export-image-name-container"] {
        margin-bottom: 20px;

        input {
            background: white;
            border-radius: 5px;
            border: none;
            color: #121212;
            padding: 7px 10px;
            font-size: 1rem;
            width: 100%;

            &:disabled {
                opacity: 0.3;
                cursor: not-allowed;
            }
        }
    }

    .buttons-continer {
        margin-top: 10px;
    }

    .v-expansion-panel {
        background: transparent;
        color: inherit;

        &:before {
            display: none;
        }

        .v-expansion-panel-header {
            padding: 0;
            min-height: auto;
            flex-direction: row-reverse;
            margin-bottom: 10px;

            &:before {
                display: none;
            }

            .v-expansion-panel-header__icon i {
                font-size: 18px;
                color: var(--font-default-color);
            }
        }

        .v-expansion-panel-content__wrap {
            padding: 0;
        }
    }

    .v-select__selections {
        color: #121212;
        font-size: 1rem;
    }
}
</style>
